/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Solution_Select_PlaceholderInputs */

const en_task_solution_select_placeholder = /** @type {(inputs: Task_Solution_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a solution…`)
};

const pt_br2_task_solution_select_placeholder = /** @type {(inputs: Task_Solution_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma resolução`)
};

/**
* | output |
* | --- |
* | "Select a solution…" |
*
* @param {Task_Solution_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_solution_select_placeholder = /** @type {((inputs?: Task_Solution_Select_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Solution_Select_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_solution_select_placeholder(inputs)
	return pt_br2_task_solution_select_placeholder(inputs)
});